import { Edit3, Trash2, Eye, Presentation, Link2 } from 'lucide-react'
import { Tooltip } from '@/components/ui/Tooltip'
import type { Proposta, PropostaItem } from '@/types'
import { PROPOSAL_PPTX_EXPORT_ENABLED } from './proposalFeatureFlags'

interface ItemActionsProps {
  proposta: Proposta
  canEdit: boolean
  dealEtapa?: string
  onEdit: (proposta: Proposta) => void
  onDelete: (id: string) => void
  onCopyLink: (proposta: Proposta) => void
  onOpenStudio?: (item: PropostaItem) => void
  onExportPPTX?: (proposta: Proposta) => void
}

export function ItemActions({
  proposta,
  canEdit,
  dealEtapa,
  onEdit,
  onDelete,
  onCopyLink,
  onOpenStudio,
  onExportPPTX,
}: ItemActionsProps) {
  const isRenegociacao = dealEtapa === 'renegociacao'
  const isHistoricalSent =
    isRenegociacao && (proposta.status === 'enviada' || proposta.status === 'aceita')
  const canEditDraft = canEdit && proposta.status === 'rascunho'

  return (
    <div className="flex items-center gap-1">
      {onOpenStudio && (
        <Tooltip content="Editar Apresentação (Studio)" position="top">
          <button
            onClick={() => onOpenStudio({ id: proposta.itens?.[0]?.id || `mock-${proposta.id}`, propostaId: proposta.id } as any)}
            className="p-1.5 rounded-md text-orange-400 hover:text-orange-300 hover:bg-orange-400/10 transition-colors"
          >
            <Presentation size={13} />
          </button>
        </Tooltip>
      )}
      {canEditDraft && (
        <>
          <Tooltip content="Editar proposta" position="top">
            <button
              onClick={() => onEdit(proposta)}
              className="p-1.5 rounded-md text-text-muted hover:text-accent hover:bg-accent/10 transition-colors"
            >
              <Edit3 size={13} />
            </button>
          </Tooltip>
          <Tooltip content="Excluir proposta" position="top">
            <button
              onClick={() => onDelete(proposta.id)}
              className="p-1.5 rounded-md text-text-muted hover:text-red-400 hover:bg-red-400/10 transition-colors"
            >
              <Trash2 size={13} />
            </button>
          </Tooltip>
        </>
      )}
      {(isHistoricalSent || (!canEdit && !canEditDraft)) && (
        <>
          <Tooltip content="Ver detalhes" position="top">
            <button
              onClick={() => onEdit(proposta)}
              className="p-1.5 rounded-md text-text-muted hover:text-accent hover:bg-accent/10 transition-colors"
            >
              <Eye size={13} />
            </button>
          </Tooltip>
          {PROPOSAL_PPTX_EXPORT_ENABLED && onExportPPTX && (
            <Tooltip content="Baixar PPTX" position="top">
              <button
                onClick={() => onExportPPTX(proposta)}
                className="p-1.5 rounded-md text-text-muted hover:text-accent hover:bg-accent/10 transition-colors"
              >
                <Presentation size={13} />
              </button>
            </Tooltip>
          )}
        </>
      )}
      {(proposta.status === 'enviada' || proposta.status === 'aceita') && (
        <Tooltip content="Copiar link" position="top">
          <button
            onClick={() => onCopyLink(proposta)}
            className="p-1.5 rounded-md text-text-muted hover:text-accent hover:bg-accent/10 transition-colors"
          >
            <Link2 size={13} />
          </button>
        </Tooltip>
      )}
    </div>
  )
}
